module.exports = __webpack_public_path__ + "img/garden.96f7c66e.jpg";